import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                          */
const PreferredStoreButton = ({ selected = false, onClick, labels }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    className: "stores-v2-preferred-store-button",
    disabled: selected,
    onClick: !selected ? onClick : void 0
  },
  /* @__PURE__ */ React.createElement(
    Icon,
    {
      name: selected ? "favourite-filled" : "favourite-empty",
      className: selected ? "stores-v2-preferred-store-button__icon--disabled" : ""
    }
  ),
  /* @__PURE__ */ React.createElement(Text, { variant: "body-head", color: selected ? "text-primary" : "primary" }, selected ? labels.preferredStore : labels.setPreferredStore)
);
export {
  PreferredStoreButton as default
};
//# sourceMappingURL=PreferredStoreButton.js.map
